/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskStatus } from './TaskStatus';
import {
    TaskStatusFromJSON,
    TaskStatusFromJSONTyped,
    TaskStatusToJSON,
    TaskStatusToJSONTyped,
} from './TaskStatus';

/**
 * 
 * @export
 * @interface InputTaskExecution
 */
export interface InputTaskExecution {
    /**
     * 
     * @type {number}
     * @memberof InputTaskExecution
     */
    taskId: number;
    /**
     * 
     * @type {string}
     * @memberof InputTaskExecution
     */
    userId: string;
    /**
     * 
     * @type {TaskStatus}
     * @memberof InputTaskExecution
     */
    taskStatus: TaskStatus;
    /**
     * 
     * @type {number}
     * @memberof InputTaskExecution
     */
    durationMilliseconds: number;
}



/**
 * Check if a given object implements the InputTaskExecution interface.
 */
export function instanceOfInputTaskExecution(value: object): value is InputTaskExecution {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('taskStatus' in value) || value['taskStatus'] === undefined) return false;
    if (!('durationMilliseconds' in value) || value['durationMilliseconds'] === undefined) return false;
    return true;
}

export function InputTaskExecutionFromJSON(json: any): InputTaskExecution {
    return InputTaskExecutionFromJSONTyped(json, false);
}

export function InputTaskExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputTaskExecution {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['task_id'],
        'userId': json['user_id'],
        'taskStatus': TaskStatusFromJSON(json['task_status']),
        'durationMilliseconds': json['duration_milliseconds'],
    };
}

export function InputTaskExecutionToJSON(json: any): InputTaskExecution {
    return InputTaskExecutionToJSONTyped(json, false);
}

export function InputTaskExecutionToJSONTyped(value?: InputTaskExecution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_id': value['taskId'],
        'user_id': value['userId'],
        'task_status': TaskStatusToJSON(value['taskStatus']),
        'duration_milliseconds': value['durationMilliseconds'],
    };
}

